import styled from 'styled-components';

export const PageWrapper = styled.div`
  background-color: #610081;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: 35px 75px;
  @media (max-width: 586px) {
    padding: 35px 0;
    min-height: 100vh;
    height: auto;
  }
`;

export const Header = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  width: 100%;
  flex-wrap: wrap;

  .contact {
    font-size: 1.4rem;
    color: #fff;
    display: flex;
    align-items: center;

    span {
      a {
        margin-left: 20px;
        border: 1px solid #fff;
        border-radius: 5px;
        padding: 12px 26px;
        text-transform: capitalize;
        font-weight: 600;
      }
    }
  }

  @media (max-width: 586px) {
    justify-content: center;
    flex-direction: column;

    .contact {
      margin: 30px 0;
    }
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  align-self: center;
  background-color: #f7f7f7;
  padding: 30px 50px;
  flex-shrink: 0;
  margin-bottom: 20px;
  border-radius: 5px;
  width: 100%;
  max-width: 534px;

  .form {
    width: 100%;
  }

  h1 {
    font-size: 2.4rem;
    color: #610082;
    font-weight: 400;
    margin-bottom: 20px;
    text-align: center;    
    width: 100%;
    border-bottom: 1px solid;
    padding-bottom: 15px;
  }

  .action {
    width: 100%;
    margin-top: 30px;

    button {
      cursor: pointer;
      height: 60px;
      font-size: 1.8rem;
      width: 100%;
      border: 0;
      background-color: #00c6c9;
      color: #fff;
      font-weight: 600;
      border-radius: 10px;
    }
  }

  @media (max-width: 586px) {
    max-width: 100%;
    border-radius: 0;
  }
`;

export const InputField = styled.div`
  width: 100%;
  margin-bottom: 20px;

  input {    
    width: 100%;
    color: #610082;
    font-size: 1.7rem;
    padding: 20px;
    border-radius: 10px;
    border: 0;
    height: 50px;
    margin-bottom: 10px;
  }

  &::placeholder {
    color: #6c6c6c;
  }
`;

export const Text = styled.p`
    font-size: 14px;
    text-align: center;
    color: #610082;
    padding: 15px 20px 0 20px;
    margin:15px 0 15px 0;
`;

export const TextEnfatic = styled.p`
  font-size: 18px;
  text-align: center;
  color: #610082;
  padding: 15px 20px 0 20px;
  margin:15px 0 45px 0;
`;

export const Footer = styled.footer`
  color: #fff;
  width: 100%;
  align-items: center;
  justify-content: space-between;

  .copyright {
    span {
      font-size: 1.4rem;
    }
  }

  @media (max-width: 586px) {
    padding: 0 10px;
  }
`;
